import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Classification, GroupClassification } from '@app-model/group-classification';
import { AdminClassificationService } from '@app-services/admin-classification.service';
import { ToastrService } from 'ngx-toastr';

import { EligibleComponent } from '../eligible.component';

@Component({
    selector: 'app-eligible-form',
    templateUrl: './eligible-form.component.html',
    styleUrls: ['./eligible-form.component.scss'],
    standalone: false
})
export class EligibleFormComponent implements OnInit, AfterViewInit {
	flagFormSubmitted = false;
	gruop = new GroupClassification();
	id;

	@Input()
	modal? = false;

	@Output()
	closeModalEvent?: EventEmitter<any> = new EventEmitter<any>();

	@ViewChildren(EligibleComponent) eligibleComponets: QueryList<EligibleComponent>;

	listComponents: EligibleComponent[] = [];

	form: UntypedFormGroup;

	loading;

	constructor(
		private adminClassificationService: AdminClassificationService,
		private router: Router,
		private route: ActivatedRoute,
		private toastr: ToastrService,
		private fb: UntypedFormBuilder
	) {
		this.initForm();
		this.loading = true;
	}

	ngAfterViewInit(): void {
		this.listComponents = this.eligibleComponets.map(m => m);

		this.eligibleComponets.changes.subscribe(comps => {
			this.listComponents = comps;
		});
		this.loading = false;
	}

	initForm() {
		this.form = this.fb.group({
			name: [
				'',
				{
					validators: [Validators.required, Validators.minLength(3)],
					updateOn: 'blur'
				}
			]
		});
	}

	isEdit() {
		if (this.route.snapshot.params.id) {
			this.id = this.route.snapshot.params.id;
			return true;
		}
		return false;
	}
	loadEdit() {
		this.adminClassificationService.getGroup(this.id).subscribe(
			res => {
				this.gruop = res as GroupClassification;
				this.form.patchValue({
					name: this.gruop.name
				});
			},
			err => {
				console.error(err);
			}
		);
	}

	ngOnInit() {
		if (this.modal) {
			this.add();
		} else {
			if (this.isEdit()) {
				this.loadEdit();
			} else {
				this.add();
			}
		}
	}
	add() {
		const cla = new Classification();
		this.gruop.classifications.push(cla);
	}
	remove(classification) {
		if (classification.id) {
			this.adminClassificationService.removeFilter(classification.id).subscribe(
				res => {
					this.gruop.classifications = this.gruop.classifications.filter(c => {
						if (c == classification) {
							return false;
						}
						return true;
					});
				},
				err => {
					console.error(err);
				}
			);
		} else {
			this.gruop.classifications = this.gruop.classifications.filter(c => {
				if (c == classification) {
					return false;
				}
				return true;
			});
		}
	}

	save(form: UntypedFormGroup) {
		this.flagFormSubmitted = true;
		if (!form.valid) {
			return;
		}

		if (!this.testClassification()) {
			this.toastr.error('Filtros inválidos');
			return;
		}
		let value = this.form.value;
		this.gruop.name = value.name;

		this.adminClassificationService.saveGroup(this.gruop).subscribe(res => {
			if (this.modal) {
				this.closeModal(res);
			} else {
				this.back();
			}
		});
	}

	closeModal(groupResult) {
		this.closeModalEvent.emit(groupResult);
	}

	back() {
		if (this.modal) {
			this.closeModal(null);
		} else {
			this.router.navigate(['/eligible']);
		}
	}

	testMasterCompany(evt) {
		let flag = true;
		this.listComponents.map(c => {
			if (c.selectedMasterCompany) {
				if (c.selectedMasterCompany.companyId === evt.companyId && evt.comp !== c) {
					flag = false;
				}
			}
		});
		evt.comp.afterSelectedMasterComany(flag);
	}

	testClassification() {
		let flag = true;
		this.listComponents.map(c => {
			if (!c.testComponent()) {
				flag = false;
			}
		});
		return flag;
	}
}
